import React from 'react'

class SetEditorMaxFreeLimitMessage extends React.Component{


	showUpgrade(){
		window.location.hash='upgrade'
	}

	render(){

		const {displayMessage}=this.props
			
		return(
			<div className='itemEditor-leftPanel-maxFreeLimitMessage' onClick={this.showUpgrade}>
				<div className={'itemEditor-leftPanel-maxFreeLimitMessage-head ' + 
						(displayMessage ? ' itemEditor-leftPanel-maxFreeLimitMessage-head--visible' : 'itemEditor-leftPanel-maxFreeLimitMessage-head--hidden')}
					onClick={this.showUpgrade}>
					Free accounts are limited to<br/>five questions per Set
				</div>
				<div className='itemEditor-leftPanel-maxFreeLimitMessage-sub'>					
					Learn about Plickers Pro
				</div>
			</div>				
		)
	}
}

export default SetEditorMaxFreeLimitMessage

